import { supabase } from './supabase';

export function hasSeenCallout(profile, key) {
  return !!profile?.dismissed_callouts?.[key];
}

export async function markCalloutSeen(profile, key) {
  if (!profile?.id) return;
  const updated = { ...(profile.dismissed_callouts || {}), [key]: true };
  await supabase.from('users').update({ dismissed_callouts: updated }).eq('id', profile.id);
}

// ── #607, Session 79.21c — SMALL UI STATE THAT BELONGS TO THE PERSON ────────
//
// Colby's ruling: the sidebar's sections remember whether they are collapsed.
//
// ON THE ACCOUNT RATHER THAN IN localStorage, and the reason is D&R's rather
// than a preference for tidiness. #7/#26 already moved callout dismissal off
// localStorage for it: STEDE SUPPORTS SHARED DEVICES BY DESIGN, so a layout
// held per DEVICE hands the next person on the shop tablet the previous
// person's sidebar — and it would not follow anybody from the tablet to their
// phone either.
//
// `dismissed_callouts` was right there and is jsonb and would have cost no
// migration. It is named for callouts. A column whose name stops describing
// its contents is how the next reader gets misled.
//
// READS TOLERATE A DATABASE WITHOUT THE COLUMN. `profile.ui_preferences` is
// simply undefined until the migration lands, so every caller falls back to
// its own default and the app behaves exactly as it did before. That matters
// because this column is NOT on production yet — it rides with Session 79.22.
export function getUiPreference(profile, key, fallback) {
  const v = profile?.ui_preferences?.[key];
  return v === undefined ? fallback : v;
}

// Best-effort by design: a failed write must never break the click that caused
// it. Somebody collapsing a section is not performing a transaction, and
// throwing here would turn a cosmetic preference into a broken menu.
export async function setUiPreference(profile, key, value) {
  if (!profile?.id) return;
  const updated = { ...(profile.ui_preferences || {}), [key]: value };
  const { error } = await supabase
    .from('users').update({ ui_preferences: updated }).eq('id', profile.id);
  if (error) console.warn('[#607] could not save a UI preference —', key, error.message);
}